export default {
  en: {
    $vuetify: {
      dataIterator: {
        rowsPerPageText: 'Items per page:',
        pageText: '{0}-{1} of {2}',
        noResultsText: 'No matching records found',
        nextPage: 'Next page',
        prevPage: 'Previous page'
      },
      dataTable: {
        rowsPerPageText: 'Rows per page:'
      },
      noDataText: 'No data available'
    }
  },
  pt: {
    $vuetify: {
      dataIterator: {
        rowsPerPageText: 'Itens por página:',
        pageText: '{0}-{1} de {2}',
        noResultsText: 'Nenhum registro encontrado',
        nextPage: 'Próxima página',
        prevPage: 'Página anterior'
      },
      dataTable: {
        rowsPerPageText: 'Linhas por página:'
      },
      noDataText: 'Sem dados disponíveis'
    }
  }
}
